import { get } from 'lodash';
import { DeviceKind } from '../constants';
import { AngularServices, getAngularServiceOrUndefined } from '../../core';
import { mockDevices } from '../../../../mocks/mock-devices';
if (localStorage.getItem('useMockDevices')) {
    mockDevices();
}
export const getEnumerateDevices = async () => {
    try {
        return await navigator.mediaDevices.enumerateDevices();
    }
    catch (err) {
        console.error('VideoProvider: navigator.mediaDevices.enumerateDevice error:', err);
        return [];
    }
};
const getAudioOutputs = (devices) => devices.filter((device) => device.kind === DeviceKind.audioOutput && device.label);
export const getDevicesWithCondition = (devices) => {
    const isSupported = get(getAngularServiceOrUndefined(AngularServices.SetSinkId), 'isSupported');
    if (devices.some((device) => device.kind === DeviceKind.audioOutput) ||
        devices.length === 0 ||
        !isSupported) {
        return devices;
    }
    return [...devices, ...getAudioOutputs(devices)];
};
const normalizeDevice = (device) => ({
    deviceId: device.deviceId,
    kind: String(device.kind)
        .replace(/input$/u, 'Input')
        .replace(/output$/u, 'Output'),
    label: device.label,
});
export const normalizeDevices = (devices) => devices.map((device) => normalizeDevice(device));
export const getDevices = async () => getEnumerateDevices().then(getDevicesWithCondition).then(normalizeDevices);
export const calculateDevicesHash = (devices) => devices.map((d) => d.label).join('-');
export const areDevicesEqual = (beforeDevice, currentDevice) => Boolean(beforeDevice) &&
    Boolean(currentDevice) &&
    beforeDevice.deviceId === currentDevice.deviceId &&
    beforeDevice.label === currentDevice.label;
